import { logger } from "./logger";
/**
 * Formatta una data in formato leggibile (GG/MM/AAAA)
 * @param date - La data da formattare (può essere stringa, null o undefined)
 * @param separator - Il separatore da utilizzare (deafult /)
 * @returns La data formattata o stringa vuota se non valida
 */
export const formatDate = (date: string | Date | null | undefined, separator?: string): string => {
    if (!date) return "N/D"; // Gestisce null, undefined e stringa vuota

    try {
        date = new Date(date);

        // Controllo aggiuntivo per date non valide
        if (isNaN(date.getTime())) {
            logger.warn("Data non valida:", date);
            return "N/D";
        }

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // mesi da 0 a 11
        const year = date.getFullYear();

        return `${day}${separator ?? "/"}${month}${separator ?? "/"}${year}`;
    } catch (e) {
        logger.error("Errore nel formattare la data:", date, e);
        return "";
    }
};
